import { ModeEvents } from "@iventis/map-engine/src/machines/map-machines.types";
import { MapEvents } from "@iventis/map-engine/src/types/map-stream.types";
import { EventStream } from "@iventis/utilities";

// If more event message types are needed, use a union type with the given generic
export const eventStream = new EventStream<ModeEvents | MapEvents>();
